;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="67ce8459-00a6-4ef9-afee-e66738146a39",e._sentryDebugIdIdentifier="sentry-dbid-67ce8459-00a6-4ef9-afee-e66738146a39")}catch(e){}}();import '../_virtual/_sentry-release-injection-file.js';

const HEADER_SERVICE_PATH = '/api/v1/header/aggregate';
const HEADER_SERVICE_PUBLIC_BASE_URL = '/api/shop-header';
var HeaderServiceInternalHost;
(function (HeaderServiceInternalHost) {
    HeaderServiceInternalHost["DEV"] = "https://shop-header-api-develop.private.zooplus.net";
    HeaderServiceInternalHost["PROD"] = "https://shop-header-api.private.zooplus.net";
    HeaderServiceInternalHost["RELEASE"] = "https://shop-header-api-release.private.zooplus.net";
    HeaderServiceInternalHost["BETA"] = "https://shop-header-api-beta.private.zooplus.net";
})(HeaderServiceInternalHost || (HeaderServiceInternalHost = {}));
function serializeConfigurationOptions(configurationOptions) {
    const queryParamKeys = [
        'showCart',
        'showCategories',
        'showMultilanguage',
        'showSearch',
        'searchFlyoutOpen',
    ];
    return queryParamKeys
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(configurationOptions[key])}`)
        .join('&');
}
function serializeBaseUrl(environment, localeOptions) {
    const { domain, locale } = localeOptions;
    const encodedDomain = encodeURIComponent(domain);
    const encodedLocale = encodeURIComponent(locale);
    const path = `${HEADER_SERVICE_PATH}/${encodedDomain}/${encodedLocale}`;
    const isClientSide = typeof window !== 'undefined';
    if (isClientSide) {
        return `${HEADER_SERVICE_PUBLIC_BASE_URL}${path}`;
    }
    const internalBaseUrl = getInternalBaseUrl(environment);
    return `${internalBaseUrl}${path}`;
}
function getInternalBaseUrl(environment) {
    switch (environment) {
        case 'prod':
            return HeaderServiceInternalHost.PROD;
        case 'beta':
            return HeaderServiceInternalHost.BETA;
        case 'dev':
            return HeaderServiceInternalHost.DEV;
        case 'release':
            return HeaderServiceInternalHost.RELEASE;
    }
}

export { serializeBaseUrl, serializeConfigurationOptions };
//# sourceMappingURL=queryUtils.js.map
